'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {filterContacts, loadIdList, loadMore} from "../Actions";
import ContactMultiSelect from "./ContactMultiSelect";

class ConnectedContactMultiSelect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        if (this.props.searchResults === undefined) this.filterContacts('');
    }

    filterContacts(filter) {
        this.props.dispatch(filterContacts(filter));
    }

    loadMore() {
        this.props.dispatch(loadMore(this.props.searchResults ? this.props.searchResults.length : 0, this.props.currentFilter));
    }

    searchResultsForSelect() {
        if (!this.props.searchResults) return undefined;
        return this.props.searchResults.map(entity => entity.forSelect());
    }

    allKnownResultsForSelect() {
        if (!this.props.allKnownResults) return undefined;
        return this.props.allKnownResults.map(entity => entity.forSelect());
    }

    render() {
        return <ContactMultiSelect
            selectedValues={this.props.selectedValues}
            open={this.props.open}
            toggle={this.props.toggle}
            updateSelectedOptions={this.props.updateSelectedOptions}
            availableValues={this.searchResultsForSelect()}
            currentFilter={this.props.currentFilter}
            updateFilter={this.filterContacts.bind(this)}
            allKnownValues={this.allKnownResultsForSelect()}
            totalAvailable={this.props.totalAvailableResults}
            loadMore={this.loadMore.bind(this)}
            moreLoading={this.props.moreLoading}
        />;
    }

}

ConnectedContactMultiSelect.getDerivedStateFromProps = (props, prevState) => {
    const selectedValuesNotPresent = props.selectedValues.filter(v => {
        return props.allKnownResults.filter(r => r.id === v).length === 0;
    });

    if (selectedValuesNotPresent.length > 0) props.dispatch(loadIdList(selectedValuesNotPresent));

    return prevState;
};

ConnectedContactMultiSelect.propTypes = {
    selectedValues: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    updateSelectedOptions: PropTypes.func.isRequired
};

function select(state) {
    return {
        currentFilter: state.contacts.currentFilter,
        searchResults: state.contacts.searchResults,
        allKnownResults: state.contacts.allKnownResults,
        totalAvailableResults: state.contacts.totalAvailableResults,
        moreLoading: state.contacts.moreLoading
    }
}

export default connect(select)(ConnectedContactMultiSelect);